var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceiptDisscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.75C11.21 22.75 10.46 22.35 9.94 21.64L8.93 20.29C8.72 20.01 8.44 19.85 8.14 19.83C7.84 19.81 7.54 19.95 7.3 20.2L6.73 19.7L7.28 20.21C5.83 21.75 4.73 21.63 4.2 21.42C3.66 21.21 2.75 20.52 2.75 18.3V7.04C2.75 2.6 4.03 1.25 8.22 1.25H15.77C19.96 1.25 21.24 2.6 21.24 7.04V18.3C21.24 20.51 20.33 21.2 19.79 21.42C19.26 21.63 18.16 21.75 16.71 20.21C16.47 19.95 16.16 19.82 15.86 19.84C15.56 19.86 15.27 20.02 15.06 20.3L14.05 21.65C13.54 22.35 12.79 22.75 12 22.75ZM8.08 18.33C8.12 18.33 8.17 18.33 8.21 18.33C8.95 18.37 9.65 18.76 10.12 19.39L11.14 20.74C11.63 21.39 12.38 21.39 12.87 20.74L13.88 19.39C14.35 18.76 15.05 18.37 15.8 18.33C16.55 18.29 17.28 18.6 17.82 19.18C18.58 19.99 19.07 20.09 19.25 20.02C19.49 19.92 19.75 19.34 19.75 18.3V7.04C19.75 3.43 19.12 2.75 15.78 2.75H8.22C4.88 2.75 4.25 3.43 4.25 7.04V18.3C4.25 19.35 4.51 19.93 4.75 20.02C4.93 20.09 5.42 19.99 6.18 19.18C6.7 18.63 7.38 18.33 8.08 18.33Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14C14.44 14 14 13.55 14 13C14 12.45 14.45 12 15 12C15.55 12 16 12.45 16 13C16 13.55 15.56 14 15 14Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9C8.44 9 8 8.55 8 8C8 7.45 8.45 7 9 7C9.55 7 10 7.45 10 8C10 8.55 9.56 9 9 9Z",
    fill: "#292D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63031 14.5498C8.44031 14.5498 8.25031 14.4798 8.10031 14.3298C7.81031 14.0398 7.81031 13.5598 8.10031 13.2698L14.8303 6.53977C15.1203 6.24977 15.6003 6.24977 15.8903 6.53977C16.1803 6.82977 16.1803 7.30977 15.8903 7.59977L9.16031 14.3298C9.02031 14.4798 8.83031 14.5498 8.63031 14.5498Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptDisscount);
export default __webpack_public_path__ + "static/media/receipt-disscount.dec4e00cfc8a72358f6351f6746f7012.svg";
export { ForwardRef as ReactComponent };